import React from 'react'
import { AudienceTags } from '../../../../shared/components/AudienceTags'
import { DataTableText } from '../../../../shared/components/DataTable'
import { LinkedRecordsCount, LinkedRecordsExpansion } from '../../../../shared/components/LinkedRecordsPanel'
import { toDisplayValue } from '../../../../shared/utils/displayValue'
import { StrategicImperative } from '../../../../shared/queries/strategicImperatives'
import { getLinkedActivityCount, getLinkedValueMessageCount } from '../StrategicImperativeTable.helpers'
import { StrategicImperativeColumnId, StrategicImperativeExpandedPanel } from '../StrategicImperativeTable.types'

export const renderStrategicImperativeCell =
    (linkedRecordsExpansion?: LinkedRecordsExpansion<StrategicImperativeExpandedPanel>) =>
    (row: StrategicImperative, columnId: StrategicImperativeColumnId) => {
        const linkedRecordsCount = (panel: StrategicImperativeExpandedPanel, count: number) => (
            <LinkedRecordsCount
                count={count}
                ownerId={row._id}
                ownerName={row.name}
                panel={panel}
                expansion={linkedRecordsExpansion}
            />
        )

        switch (columnId) {
            case 'name':
                return (
                    <DataTableText
                        text={toDisplayValue(row.name)}
                        variant="16x600"
                        color="figma.grayscale.textHier1"
                        maxLines={3}
                    />
                )
            case 'audiences':
                return <AudienceTags audiences={row.audiences} maxVisible={3} />
            case 'linkedActivities':
                return linkedRecordsCount('activities', getLinkedActivityCount(row))
            case 'linkedValueMessages':
                return linkedRecordsCount('valueMessages', getLinkedValueMessageCount(row))
            default:
                return null
        }
    }
